/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinginstagram1Inputs */

const en_crosspostinginstagram1 = /** @type {(inputs: Crosspostinginstagram1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const de_crosspostinginstagram1 = /** @type {(inputs: Crosspostinginstagram1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

/**
* | output |
* | --- |
* | "Instagram" |
*
* @param {Crosspostinginstagram1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinginstagram1 = /** @type {((inputs?: Crosspostinginstagram1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinginstagram1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinginstagram1(inputs)
	return de_crosspostinginstagram1(inputs)
});
export { crosspostinginstagram1 as "crosspostingInstagram" }